export default __webpack_public_path__ + "static/media/swap-right.9d0db2c7.svg";